import { CatDignity, DogDignity } from '@/shared/types';
import {
  BreedChampion,
  ColorChampion,
  CountryChampion,
  GrandCountryChampion,
  GrandInterChampion,
  GrandInterPremior,
  HonoraryManufacturer,
  HonoraryWinnerOfExhibitions,
  InterPremior,
  JuniorBreedChampion,
  JuniorCountryChampion,
  JuniorCountryGrandChampion,
  Premior,
  SuperGrandChampion,
  SupremeChampion,
  SupremePremior,
  VeteranChampion
} from '@/shared/ui';

export const DogTitleMap = {
  ЮЧП: <JuniorBreedChampion width={80} height={80} />,
  ЮЧБ: <JuniorCountryChampion width={80} height={80} />,
  ЮГЧБ: <JuniorCountryGrandChampion width={80} height={80} />,
  ЧП: <BreedChampion width={80} height={80} />,
  ЧБ: <CountryChampion width={80} height={80} />,
  ГЧБ: <GrandCountryChampion width={80} height={80} />,
  СГЧБ: <SuperGrandChampion width={80} height={80} />,
  ВЧБ: <VeteranChampion width={80} height={80} />
} satisfies { [key in DogDignity]: React.ReactNode };

export const DogTitleMapHint = {
  ЮЧП: 'Юный чемпион породы',
  ЮЧБ: 'Юный чемпион Беларуси',
  ЮГЧБ: 'Юный гранд чемпион Беларуси',
  ЧП: 'Чемпион породы',
  ЧБ: 'Чемпион Беларуси',
  ГЧБ: 'Гранд чемпион Беларуси',
  СГЧБ: 'Супер гранд чемпион Беларуси',
  ВЧБ: 'Ветеран чемпион Беларуси'
} as { [key in DogDignity]: string };

export const CatTitleMap = {
  JW: <JuniorBreedChampion width={80} height={80} />,
  DM: <HonoraryManufacturer width={80} height={80} />,
  DVM: <ColorChampion width={80} height={80} />,
  DSM: <HonoraryWinnerOfExhibitions width={80} height={80} />,
  CH: <BreedChampion width={80} height={80} />,
  PR: <Premior width={80} height={80} />,
  IC: <GrandInterChampion width={80} height={80} />,
  IP: <InterPremior width={80} height={80} />,
  GIC: <GrandCountryChampion width={80} height={80} />,
  GIP: <GrandInterPremior width={80} height={80} />,
  SC: <SupremeChampion width={80} height={80} />,
  SP: <SupremePremior width={80} height={80} />,
  EC: <JuniorCountryGrandChampion width={80} height={80} />,
  EP: <CountryChampion width={80} height={80} />,
  WW: <SuperGrandChampion width={80} height={80} />,
  SW: <VeteranChampion width={80} height={80} />
} satisfies { [key in CatDignity]: React.ReactNode };

export const CatTitleMapHint = {
  JW: 'Молодой Победитель',
  DM: 'Почетный производитель',
  DVM: 'Почетный Победитель в Окрасе',
  DSM: 'Почетный Победитель Выставок',
  CH: 'Чемпион',
  PR: 'Премиор',
  IC: 'Интерчемпион',
  IP: 'Интерпремиор',
  GIC: 'Грандинтерчемпион',
  GIP: 'Грандинтерпремиор',
  SC: 'Суприм чемпион (с 01.01.2009)',
  SP: 'Суприм премиор (с 01.01.2009)',
  EC: 'Европейский чемпион (до 01.01.2009)',
  EP: 'Европейский премиор (до 01.01.2009)',
  WW: 'Мировой Победитель',
  SW: 'Победитель Скандинавии'
} as { [key in CatDignity]: string };
